const admins = [
  '18VbaGIvbGdpzTPn4dSNTZWgdii1',
  'dN3FMOK3zUg5pUFvYrjDGLiEmNt1',
  'AySCYjfiXEOmMfDS8hgqb0KcGg72',
];

const isAdmin = user =>
  admins.indexOf(user.uid) !== -1;

export default isAdmin;



// WEBPACK FOOTER //
// ./src/utils/isAdmin.js